import {
  AbandonedPatientConversationQuery,
  AbandonedPatientConversationQueryVariables,
  AddPatientAnswerConversationQuery,
  AddPatientAnswerConversationQueryVariables,
  BackendModelInfoFragment,
  BackendModelQuery,
  BuildCaseFromConversationQuery,
  BuildCaseFromConversationQueryVariables,
  BuildCaseOptions,
  CaseConditionInput,
  CaseFindingPresentationType,
  CheckForPiiQuery,
  ConversationContext,
  ConversationExchangeResultFragment,
  ConversationNextQuestionQuery,
  ConversationQuestionType,
  CopyPatientCaseMutation,
  DdFromConversationQuery,
  DdOverviewQuery,
  DdReportOnlyQuery,
  DdWithCaseFindings,
  DdWithCaseQuery,
  DebugForLastQuestionQuery,
  DiseaseCategoryType,
  DiseaseReferenceDataFragment,
  DiseaseReferenceOverviewDataFragment,
  DiseasesAliasing,
  DoPatientExchangeQuery,
  DrAndCohortPairQuery,
  DrAndFindingPairQuery,
  DrByFeatureQuery,
  DrOverviewByFeatureQuery,
  FeatureByIdQuery,
  FindingSource,
  FreeTextToPatientCaseQuery,
  GetGraphByIdsQuery,
  GetPanelQuery,
  GetPanelWithChildrenQuery,
  GetRecommendationsQuery,
  GetUserRolesQuery,
  GraphData,
  GroundTextQuery,
  GroupedFeature,
  GroupedFeatureResponseFragment,
  GVersionState,
  LambdaTestsMutation,
  LoadedModelInfoFragment,
  Maybe,
  MetricsPathsQuery,
  MetricsPreloadMutation,
  MetricsQfQuery,
  MissingInCaseAction,
  NextResponseQuery,
  NodeType,
  PatientCaseGroupedFeature,
  PatientCaseMetaDataQuery,
  PatientSummaryByCaseQuery,
  PatientSummaryByContextQuery,
  PatientSummaryQuery,
  PersistConversationByIdQuery,
  PersistConversationQuery,
  PlanQuery,
  QfsCorrelateListsQuery,
  QfsCorrelateQuery,
  QualifiedFeature,
  QualifiedFeatureFragment,
  QualifiedFeatureInput,
  Qualifier,
  QualifierSearchQueryQuery,
  RestoreCaseQuery,
  RestoreConversationQuery,
  RestoreOpaqueDataQuery,
  RestorePatientCaseQuery,
  RunLoadersStatusQueryQuery,
  SaveAsPatientConversationQuery,
  SavedCaseGroupInput,
  SearchQualifiedFeaturesQueryQuery,
  SendFeedbackMutation,
  SetVersionRunningEnvMutation,
  SetVersionStateMutation,
  SortType,
  StartConversationQuery,
  StoreOpaqueDataMutation,
  StorePatientCaseMutation,
  SubStatus,
  SummaryInput,
  UndoConversationQuery,
  UpdateOpaqueDataMutation,
  UpdatePatientCaseMutation,
  UpdatePatientSummaryMutation,
  Web,
  GetGraphQuery,
  DdWithCaseQueryVariables,
  GetPanelQueryVariables,
  DdWithCaseClinicalReasoning,
  RestoreCaseQueryVariables,
  StorePatientCaseMutationVariables,
  PatientCaseMetaDataQueryVariables,
  CopyPatientCaseMutationVariables,
  UpdatePatientCaseMutationVariables,
  RestorePatientCaseQueryVariables,
  SendFeedbackMutationVariables,
  DdOverviewQueryVariables,
  DdReportOnlyQueryVariables,
  PlanQueryVariables,
  GetGraphQueryVariables,
  GetGraphByIdsQueryVariables,
  DrOverviewByFeatureQueryVariables,
  DrByFeatureQueryVariables,
  DrAndFindingPairQueryVariables,
  DrAndCohortPairQueryVariables,
  GetPanelWithChildrenQueryVariables,
  SearchQualifiedFeaturesQueryQueryVariables,
  QualifierSearchQueryQueryVariables,
  FeatureByIdQueryVariables,
  DoPatientExchangeQueryVariables,
  NextResponseQueryVariables,
  StartConversationQueryVariables,
  StoreOpaqueDataMutationVariables,
  OpaqueDataScalar,
  RestoreOpaqueDataQueryVariables,
  PatientSummaryQueryVariables,
  UpdatePatientSummaryMutationVariables,
  DdFromConversationQueryVariables,
  PatientSummaryByCaseQueryVariables,
  PatientSummaryByContextQueryVariables,
  MetricsQfQueryVariables,
  QfsCorrelateQueryVariables,
  QfsCorrelateListsQueryVariables,
  RestoreConversationQueryVariables,
  GetRecommendationsQueryVariables,
  DebugForLastQuestionQueryVariables,
  ConversationNextQuestionQueryVariables,
  PersistConversationQueryVariables,
  PersistConversationByIdQueryVariables,
  UndoConversationQueryVariables,
  MetricsPathsQueryVariables,
} from "fe-common/graphql";
import ApolloClient from "apollo-client";
import gql from "graphql-tag";
import { GenderValue, KahunCategories } from "shared";
import { CaseQualifiedFeature } from "../../logic/qualifiedFeature/CaseQualifiedFeature";
import {
  asGroupedFeature,
  asQualifiedFeatureInput,
  asQualifiedFeatureInputFromW,
} from "./daoTypesConverte";
import { GraphQuery } from "../graph";
import { Web_Solver } from "../webSolver";
import { DiseaseReferenceQuery } from "../diseaseReferenceGQL";
import { getDataForPatientCase } from "./storeCaseRequestBuilders";
import { BaseDao } from "./baseDao";
import { WQualifiedFeature } from "@kahunmedical/common-wtypes";
import {
  ConfigurationSettingList,
  MergedConfigurationSettings,
  SummaryOptions,
} from "@kahunmedical/common-configuration";
import { ConfigSubObjectKeys } from "@kahunmedical/common-configuration/dist/generated";
import { GroundingQuery } from "../grounding";

type DDOptions = Pick<DdWithCaseQueryVariables, "depth" | "limit">;
type Modify<T, R> = Omit<T, keyof R> & R; // nicer syntax for Omit
type BackendComponent = keyof Omit<BackendModelInfoFragment, "__typename">;

export const GENDER_MALE_FEATURE_ID = "FE.2f94aa86-ac10-4b82-ab9b-b9ae3d0dfb96";
export const GENDER_FEMALE_FEATURE_ID =
  "FE.4aa7c292-3270-43a2-a012-753888709f4e";
export const RANGE_QUALIFIER_FEATURE_ID =
  "FE.8422bf05-f6ff-4e16-91ee-6644a0304eed";

export const GENDER_FEATURE_MAPPING = {
  Male: GENDER_MALE_FEATURE_ID,
  Female: GENDER_FEMALE_FEATURE_ID,
};
export const AGE_RELATION_ID = "RE.39049194-f191-40b1-8820-4437d725637e";
export const AGE_FEATURE_ID = `FE.SUBPOP.${AGE_RELATION_ID}`;

export type Panel = GetPanelQuery["panel"];

// wrangle the DD types to add extra data
export type DDFinding = Modify<
  DdWithCaseFindings,
  { qf: QualifiedFeatureFragment }
>;
export type DDClinicalReasoning = Modify<
  DdWithCaseClinicalReasoning,
  { findings: Maybe<DDFinding[]> }
>;
export type DDResult = Modify<
  DdWithCaseQuery["dd"],
  { clinicalReasoning: Maybe<DDClinicalReasoning[]> }
>;

export type DiseaseForPlan = {
  disease: QualifiedFeature;
  prob?: number;
};

const TypeIntrospectionQuery = gql`
  query getOptions($name: String!) {
    __type(name: $name) {
      name
      inputFields {
        name
        defaultValue
        type {
          name
        }
      }
    }
  }
`;

class DebugForLastQuestionVariables {}

export class WebDao extends BaseDao {
  externalFlags: any;

  constructor(
    public gqlClient: (cached?: boolean) => Promise<ApolloClient<any>>,
    /* V1 settings - TODO: remove once we get there */
    featureFlags?: any,
    /* V2 settings */
    private settings?: MergedConfigurationSettings,
  ) {
    super(gqlClient);
    this.externalFlags = featureFlags || {};
  }

  updateExternalFeatureFlags = (flags) => {
    this.externalFlags = flags || {};
  };

  updateSettingsObject = (newObject: MergedConfigurationSettings) => {
    // console.log("WEBDAO: updateSettingsObject", newObject, newObject?.merged);
    this.settings = newObject;
  };

  public getSettings(): MergedConfigurationSettings {
    return this.settings;
  }

  private async getConversationOptions() {
    // Make sure we wait to get the settings
    return (
      this.settings?.getSettingsForSubObject(
        ConfigSubObjectKeys.conversation,
      ) || {}
    );
  }
  private async getAgentDiagnosisOptions() {
    return (
      this.settings?.getSettingsForSubObject(
        ConfigSubObjectKeys.conversation_resultsDD,
      ) || {}
    );
  }

  modelRevisionInUse: Partial<
    Record<BackendComponent, LoadedModelInfoFragment>
  > = {};

  getModelRevisionInUse() {
    return this.modelRevisionInUse;
  }

  async refreshModelRevisionInUse() {
    let result = await this.doQuery<BackendModelQuery>({
      query: Web.BackendModel,
    });
    this.updateModelRevisionInUse(result);
    return result;
  }

  async queryFeatureById(id: string, qfLight = true) {
    let result = await this.doQuery<FeatureByIdQuery>({
      query: Web.FeatureById,
      variables: { id, qfLight },
    });
    return result;
  }

  updateModelRevisionInUse(response: BackendModelInfoFragment) {
    const components: BackendComponent[] = ["diagnosisModel", "gatewayModel"];
    components.forEach((key) => {
      if (response?.[key]) this.modelRevisionInUse[key] = response[key];
    });
  }

  async restoreCase(features: QualifiedFeatureInput[]) {
    let variables: RestoreCaseQueryVariables = { findings: features };
    let query = Web.RestoreCase;
    let result = await this.doQuery<RestoreCaseQuery>({
      query,
      variables,
    });
    return result.qualifiedFeatures;
  }

  async storePatientCase(
    qfs: SavedCaseGroupInput[],
    considerPanels?: string[],
    auto: boolean = false,
    clinicId: string = null,
    readOnly: boolean = undefined,
  ) {
    const data = getDataForPatientCase(considerPanels);
    const variables: StorePatientCaseMutationVariables = {
      qfs,
      data,
      auto,
      clinicId,
      readOnly,
    };
    return (
      await this.doMutate<StorePatientCaseMutation>({
        mutation: Web.StorePatientCase,
        variables,
      })
    ).storePatientCase;
  }

  async getPatientCaseMetaData(id: string) {
    const variables: PatientCaseMetaDataQueryVariables = {
      id,
    };

    return (
      await this.doQuery<PatientCaseMetaDataQuery>({
        query: Web.PatientCaseMetaData,
        variables,
      })
    ).patientCaseMetaData;
  }

  async copyPatientCase(id: string, clinicId?: string) {
    const variables: CopyPatientCaseMutationVariables = { id, clinicId };
    return (
      await this.doMutate<CopyPatientCaseMutation>({
        mutation: Web.CopyPatientCase,
        variables,
      })
    ).copyPatientCase;
  }

  async updatePatientCase(
    qfs: SavedCaseGroupInput[],
    considerPanels: string[],
    id: string,
    etag: string,
    clinicId: string,
  ) {
    const data = getDataForPatientCase(considerPanels, true);

    const variables: UpdatePatientCaseMutationVariables = {
      qfs,
      data,
      id,
      etag,
      clinicId,
    };
    return (
      await this.doMutate<UpdatePatientCaseMutation>({
        mutation: Web.UpdatePatientCase,
        variables,
      })
    ).updatePatientCase;
  }

  async restorePatientCase(id: string, clinicId?: string) {
    const variables: RestorePatientCaseQueryVariables = {
      id,
      clinicId,
    };
    const patientCaseRes = (
      await this.doQuery<RestorePatientCaseQuery>({
        query: Web.RestorePatientCase,
        variables,
      })
    ).restorePatientCase;
    return {
      findings: (patientCaseRes.findings?.reduce((acc, item) => {
        acc[item.group] = item.features;
        return acc;
      }, {}) || {}) as Record<string, PatientCaseGroupedFeature[]>,
      etag: patientCaseRes.etag,
      data: patientCaseRes.data,
      caseId: id,
    };
  }

  async sendFeedback(
    text: string,
    sharedCase: string, //full share url
    sender: string,
    sharedCaseId?: string, //case id to duplicate
    urlPrefix?: string, //prefix to be added before the duplicated case's url
    clinicName?: string,
    rating?: number,
  ): Promise<boolean> {
    const variables: SendFeedbackMutationVariables = {
      rating,
      clinicName,
      text,
      sharedCase,
      sharedCaseId,
      urlPrefix,
      sender,
    };

    const result = await this.doMutate<
      SendFeedbackMutation,
      SendFeedbackMutationVariables
    >({
      variables,
      mutation: Web.SendFeedback,
    });
    return result.sendFeedback;
  }

  async fetchQualifiedFeatures(
    findings: QualifiedFeatureInput[],
  ): Promise<QualifiedFeatureFragment[]> {
    let variables: RestoreCaseQueryVariables = { findings };
    let result = await this.doQuery<RestoreCaseQuery>({
      query: Web.RestoreCase,
      variables,
    });
    return result.qualifiedFeatures;
  }

  async fetchQualifiedFeature(
    finding: QualifiedFeatureInput,
  ): Promise<QualifiedFeatureFragment> {
    const result: QualifiedFeatureFragment[] = await this.fetchQualifiedFeatures(
      [finding],
    );
    if (result.length === 1) {
      return result[0];
    }
  }

  async getDDOverview(
    qfs: QualifiedFeature[],
    consider?: QualifiedFeature[],
    ddOptions?: DDOptions,
    cached = false,
  ) {
    let variables: DdOverviewQueryVariables = {
      qfs: qfs.map(asQualifiedFeatureInput),
      consider: consider.map(asQualifiedFeatureInput),
      diagnosisOptions: this.getAgentDiagnosisOptions(),
      ...ddOptions,
    };
    let results = await this.doQuery<DdOverviewQuery>(
      {
        query: Web.DDOverviewQuery,
        variables,
      },
      cached,
    );
    return results.dd;
  }

  getDDFindings(dd) {
    const idToFinding = dd?.allFindings?.reduce((acc, f) => {
      acc[f.id] = f;
      return acc;
    }, {});

    dd?.clinicalReasoning?.forEach((c) => {
      c.findings = idToFinding
        ? c.findings?.map((f) => ({
            ...f,
            qf: idToFinding[f.finding.id],
          }))
        : null;
    });

    return dd;
  }

  async getDDWithCase({
    qfs,
    considerPanels,
    diseasesToDiscard = [],
    diseasesToAdd = [],
    ddOptions,
    pathOptions,
    cached = false,
    withDebug = false, //maybe this should be moved to DDOptions, or removed once we established a debugger-mode
    caseConditions = [],
    backEndMode = false,
    sortTypes = undefined, //default to all sort types
    includeCitations = true,
    caseId = null,
  }: {
    qfs?: Partial<Record<CaseFindingPresentationType, QualifiedFeature[]>>;
    considerPanels?: string[];
    diseasesToDiscard?: QualifiedFeature[];
    diseasesToAdd?: Partial<QualifiedFeature>[];
    ddOptions?: DDOptions;
    pathOptions?: any; //<---these should be deprecated, defaults come from the configuration system
    cached?;
    withDebug?; //maybe this should be moved to DDOptions, or removed once we established a debugger-mode
    caseConditions?: CaseConditionInput[];
    backEndMode?: boolean;
    sortTypes?: SortType[]; //deafault to all sorttypes
    includeCitations?: boolean;
    caseId?;
  }): Promise<DDResult> {
    let gfeatures = this.asGFeatures(qfs);

    if (withDebug) pathOptions = { ...pathOptions, outputUsedPaths: true };

    const options = await this.getAgentDiagnosisOptions();
    let variables: DdWithCaseQueryVariables = {
      qfs: gfeatures,
      considerPanels: considerPanels,
      diagnosisOptions: {
        ...pathOptions,
        ...options,
      },
      withDebug,
      ...ddOptions,
      diseasesToDiscard:
        diseasesToDiscard?.map((d) => asQualifiedFeatureInput(d)) || [],
      diseasesToAdd:
        diseasesToAdd?.map((d) => asQualifiedFeatureInput(d)) || [],
      sortTypes,
      conditions: caseConditions,
      backEndMode,
      includeCitations,
      caseId: caseId,
    };

    let results = await this.doQuery<DdWithCaseQuery>(
      {
        query: Web.DDWithCaseQuery,
        variables,
      },
      cached,
    );

    // translate sourceQFIndex
    let dd: DDResult = results?.dd as DDResult; // this works because DDResult is an expansion of the returned types

    const updatedDD = this.getDDFindings(dd);

    return updatedDD;
  }

  async getDDReportOnly(
    qfs: Partial<Record<CaseFindingPresentationType, QualifiedFeature[]>>,
    considerPanels?: string[],
    diseasesToDiscard?: QualifiedFeature[],
    diseasesToAdd?: QualifiedFeature[],
    panelsToAdd?: QualifiedFeature[],
    ddOptions?: DDOptions,
    diagnosisOptions?: ConfigurationSettingList,
    //pathOptions?: any, //<--depricated, settings should come from configuration system (diagnosisOptions)
    cached = false,
    withDebug = false, //maybe this should be moved to DDOptions, or removed once we established a debugger-mode
    caseConditions: CaseConditionInput[] = [],
    backEndMode: boolean = false,
    sortTypes: SortType[] = undefined, //all sorttypes
  ) {
    let gfeatures = this.asGFeatures(qfs);

    //if (withDebug)
    //  pathOptions = {
    //    ...pathOptions,
    //    outputUsedPaths: true,
    //    forceRecompute: true,
    //  };
    if (withDebug)
      diagnosisOptions = {
        ...diagnosisOptions,
        outputUsedPaths: true,
        forceRecompute: true,
      };

    let variables: DdReportOnlyQueryVariables = {
      qfs: gfeatures,
      considerPanels: considerPanels,
      diagnosisOptions: { ...diagnosisOptions }, //todo joseph, why not using default values?
      //pathOptions: { ...pathOptions },
      ...ddOptions,
      diseasesToDiscard:
        diseasesToDiscard?.map((d) => asQualifiedFeatureInput(d)) || [],
      diseasesToAdd:
        diseasesToAdd?.map((d) => asQualifiedFeatureInput(d)) || [],
      sortTypes,
      conditions: caseConditions,
    };

    let results = await this.doQuery<DdReportOnlyQuery>(
      {
        query: Web.DDReportOnlyQuery,
        variables,
      },
      cached,
    );

    // translate sourceQFIndex
    const dd = results?.dd;

    return dd;
  }

  private asGFeatures(
    qfs: Partial<Record<CaseFindingPresentationType, QualifiedFeature[]>>,
    source = FindingSource.Physician,
  ) {
    // create grouped items
    let flatFeatures =
      qfs &&
      Object.entries(qfs).flatMap(([group, list]) =>
        list.map(
          (qf) =>
            [group, qf] as [CaseFindingPresentationType, QualifiedFeature],
        ),
      );

    let gfeatures =
      flatFeatures &&
      flatFeatures.map(([group, qf]) => asGroupedFeature(group, source)(qf));
    return gfeatures;
  }

  async getPlan(
    qfs: Partial<Record<CaseFindingPresentationType, QualifiedFeature[]>>,
    diseases?: DiseaseForPlan[],
    pathOptions?: any, //<--depricated, should get options from configuration system
    withDebug = false,
    categories: DiseaseCategoryType[] = undefined,
    includeDiseaseMetrics = true,
    defaultLimit: number = 25,
    limitPerCategory: { [category: string]: number } = {},
    aliasing: DiseasesAliasing[] = [],
    caseId: string = null,
  ) {
    let gfeatures = this.asGFeatures(qfs);

    let variables: PlanQueryVariables = {
      patientCase: { findings: gfeatures },
      diseases: diseases.map((d) => ({
        disease: asQualifiedFeatureInput(d.disease),
        prob: d.prob,
      })),
      diagnosisOptions: pathOptions,
      withDebug,
      categories,
      withDiseaseMetrics: includeDiseaseMetrics,
      limit: defaultLimit,
      limitPerCategory: Object.entries(limitPerCategory).map(
        ([category, limit]) => ({
          category: category as DiseaseCategoryType,
          limit,
        }),
      ),
      diseasesAliasing: aliasing,
      caseId,
    };

    const result = await this.doQuery<PlanQuery>(
      {
        query: Web.Plan,
        variables,
      },
      false,
    );

    return result.plan;
  }

  async getOverview(diseaseId: string, cached = false): Promise<any> {
    let result = await this.doQuery<any>(
      {
        query: Web_Solver.DVOverviewQuery,
        variables: { f: diseaseId },
      },
      cached,
    );

    return result.feature;
  }

  async getDV(
    diseaseid: string,
    filters: QualifiedFeatureInput[] = null,
    cached = false,
  ): Promise<any> {
    let variables: any = {
      qf: { feature: diseaseid },
      filters: filters || [],
    };
    let result = await this.doQuery<any>(
      {
        query: Web_Solver.DiseaseViewQuery,
        variables,
      },
      cached,
    );
    return result.diseaseView;
  }

  async groundText(text: string, caseId: string = null) {
    let result = await this.doQuery<GroundTextQuery>({
      query: GroundingQuery.Grounding,
      variables: { text, caseId: caseId?.length > 0 ? caseId : null },
    });
    return result.groundText;
  }

  async getGraphV2(
    source: QualifiedFeatureFragment,
    target: GroupedFeature[],
    cached = false,
  ) {
    let variables: GetGraphQueryVariables = {
      root: { feature: source.feature.id },
      nodes: target,
    };
    let result = await this.doQuery<GetGraphQuery>(
      {
        query: GraphQuery.Graph,
        variables,
      },
      cached,
    );

    return result.graph;
  }
  async getGraphByIds(
    root: string,
    subtypes: string[],
    active: string[],
    background: string[],
    simplify = true,
    cached = false,
  ) {
    let variables: GetGraphByIdsQueryVariables = {
      root,
      background,
      subtypes,
      active,
      simplify,
    };
    let result = await this.doQuery<GetGraphByIdsQuery>(
      {
        query: GraphQuery.GraphByIDS,
        variables,
      },
      cached,
    );

    return result.graphByCohorts;
  }

  async getDiseaseReferenceByFeature(
    source: string,
    category: DiseaseCategoryType,
    cached = false,
    withCitations = false,
  ): Promise<DiseaseReferenceDataFragment> {
    let variables: DrByFeatureQueryVariables = {
      featureid: source,
      category: category,
      withCitations: withCitations,
    };
    let result = await this.doQuery<DrByFeatureQuery>(
      {
        query: DiseaseReferenceQuery.DISEASE_BY_FEATURE,
        variables,
      },
      cached,
    );

    return result.reference.disease;
  }

  async getDiseaseOverviewByFeature(
    source: string,
    cached = false,
  ): Promise<DiseaseReferenceOverviewDataFragment> {
    let variables: DrOverviewByFeatureQueryVariables = {
      featureid: source,
    };
    let result = await this.doQuery<DrOverviewByFeatureQuery>(
      {
        query: DiseaseReferenceQuery.DISEASE_OVERVIEW,
        variables,
      },
      cached,
    );

    return result?.reference?.disease;
  }

  async getDiseaseReferenceWithFinding(
    source: string,
    finding: QualifiedFeature,
    cached = false,
  ) {
    let variables: DrAndFindingPairQueryVariables = {
      featureid: source,
      finding: asQualifiedFeatureInput(finding),
    };
    let result = await this.doQuery<DrAndFindingPairQuery>(
      {
        query: DiseaseReferenceQuery.DISEASE_FINDING_PAIR,
        variables,
      },
      cached,
    );

    return result.reference.diseaseWithFinding;
  }
  async getDiseaseReferenceWithCohort(
    source: string, // cohortid
    cohort: string, // cohortid
    cached = false,
  ): Promise<DiseaseReferenceDataFragment> {
    let variables: DrAndCohortPairQueryVariables = {
      diseaseCohortid: source,
      cohortid: cohort,
    };
    let result = await this.doQuery<DrAndCohortPairQuery>(
      {
        query: DiseaseReferenceQuery.DISEASE_COHORT_PAIR,
        variables,
      },
      cached,
    );

    return result.reference.diseaseWithFinding;
  }

  async getGraphWithInputs(
    source: QualifiedFeatureFragment,
    target: QualifiedFeatureInput[],
    depth = 3,
    pathOptions?: any,
    cached = false,
  ) {
    return this.getGraphV2(
      source,
      target.map((qf) => ({
        feature: qf,
        group: CaseFindingPresentationType.ActiveFinding,
      })),
      cached,
    );
  }

  async getGraphWithFeatures(
    source: QualifiedFeature,
    target: Partial<Record<CaseFindingPresentationType, QualifiedFeature[]>>,
    depth = 3,
    pathOptions?: any,
    cached = false,
  ) {
    let gFeatures = this.asGFeatures(target);

    const result = await this.getGraphV2(source, gFeatures, cached);

    //handle sourceQualifiedIndex
    //const targetFindings = target.filter(t => t.t)
    result?.graph?.nodes?.forEach((n) => {
      if (n.type === NodeType.Finding) {
        (n as any).sourceQF = target[n.sourceQFIndex];
      }
    });

    return result;
  }

  async getGraphWithCase(
    disease: QualifiedFeatureFragment,
    targets: CaseQualifiedFeature[],
    depth = 3,
    pathOptions?: any,
    filterNegated = true,
    cached = false,
  ) {
    if (targets.length == 0) {
      return null;
    }

    const inputGroupFeatures: GroupedFeature[] = targets
      .filter((cqf) =>
        filterNegated ? !cqf.finding.negate : cqf.finding.negate,
      )
      .map((cqf) => ({
        group: cqf.group,
        feature: asQualifiedFeatureInput(cqf.finding),
      }));

    return await this.getGraphV2(disease, inputGroupFeatures, cached);
  }

  async getPathGraph(
    source: QualifiedFeatureFragment,
    target: QualifiedFeatureFragment,
    filters: QualifiedFeatureInput[] = null,
    cached = false,
  ): Promise<GraphData> {
    const ret = await this.getGraphWithFeatures(source, {
      [CaseFindingPresentationType.ActiveFinding]: [target],
    });
    return ret.graph;
  }

  async getPanel(id: string, cached = false): Promise<Panel> {
    let variables: GetPanelQueryVariables = {
      id,
    };
    let results = await this.doQuery<GetPanelQuery>(
      {
        query: Web.PanelQuery,
        variables,
      },
      cached,
    );
    return results.panel;
  }

  async getPanelChildren(id: string, cached = false): Promise<Panel[]> {
    let variables: GetPanelWithChildrenQueryVariables = {
      id,
    };
    let results = await this.doQuery<GetPanelWithChildrenQuery>(
      {
        query: Web.PanelChildrenQuery,
        variables,
      },
      cached,
    );
    return results?.panel?.children;
  }

  async searchQualifiedFeatures(
    search: string,
    categories: (KahunCategories | string)[],
    gender: GenderValue,
    patientFacing: boolean = false,
    panelIds: string[] = null,
    ancestors: string[] = null,
    cached = false,
  ): Promise<QualifiedFeature[]> {
    const options = await this.getConversationOptions();
    let variables: SearchQualifiedFeaturesQueryQueryVariables = {
      qfLight: true,
      search,
      categories,
      gender,
      patientFacing,
      panelIds,
      ancestors,
      customPatientFacingPropertyValues: options?.customPatientFacingPropertyValues as string[],
    };
    let results = await this.doQuery<SearchQualifiedFeaturesQueryQuery>(
      {
        query: Web.SearchQuery,
        variables,
      },
      cached,
    );
    return results?.qualifiedFeatureSearch;
  }

  async searchQualifiers(
    search: string,
    feature: string,
    relation?: string,
    cached = false,
  ): Promise<Qualifier[]> {
    let variables: QualifierSearchQueryQueryVariables = {
      feature,
      search,
      relation,
    };
    let results = await this.doQuery<QualifierSearchQueryQuery>(
      {
        query: Web.QualiferSearchQuery,
        variables,
      },
      cached,
    );
    return results?.qualifierSearch;
  }

  /**
   * @deprecated use getPanelChildren
   * @param ids
   * @param cached
   */
  async getPanels(ids: string[], cached = false): Promise<Panel[]> {
    // bad practice but lets just build the whole thing dynamically
    let inner = ids
      .map(
        (id, ix) => `
      i_${ix}: panel(id: "${id}"){...Panel}
    `,
      )
      .join("\n");
    let query = gql`
      query GetPanels {
        ${inner}
      }
      ${Web.PanelFragment}
    `;
    let results = await this.doQuery<any>(
      {
        query,
        variables: {},
      },
      cached,
    );
    return results && Object.values(results);
  }

  getCaseConditionForId(featureId: string): CaseConditionInput {
    return {
      featureid: featureId,
      type: "TOP_X",
      payload: { val: 1 },
    };
  }

  async getQualifiedFeatureForId(featureId: string) {
    const input = asQualifiedFeatureInput({
      feature: {
        id: featureId,
        shortname: null,
        organSystem: null,
        name: null,
        category: null,
      } as any,
    });

    let variables: RestoreCaseQueryVariables = {
      findings: [input],
    };
    let results = await this.doQuery<RestoreCaseQuery>({
      query: Web.RestoreCase,
      variables,
    });
    return (
      results.qualifiedFeatures &&
      results.qualifiedFeatures.length > 0 &&
      results.qualifiedFeatures[0]
    );
  }

  async getFeatureById(featureId: string) {
    let variables: FeatureByIdQueryVariables = {
      id: featureId,
    };
    let results = await this.doQuery<FeatureByIdQuery>({
      query: Web.FeatureById,
      variables,
    }).catch((e) => {
      console.log("getFeatureById error", e);
      return null;
    });
    return results?.feature;
  }

  async getRunsInfo(env: string = "production", cached = false) {
    let result = await this.doQuery<RunLoadersStatusQueryQuery>(
      {
        query: Web.RunLoaderStatus,
        variables: { env },
      },
      cached,
    );
    return result.runLoadersStatus;
  }

  async metricsPreload(
    env: string,
    filter: string,
    shards: number,
    taskversion: string,
    cached = false,
  ): Promise<string> {
    let result = await this.doMutate<MetricsPreloadMutation>(
      {
        mutation: Web.MetricsPreload,
        variables: { env, filter, shards, taskversion },
      },
      cached,
    );
    return result.metricsPreload.success;
  }
  async freeTextToPateintCaseFinding(text: string) {
    let result = await this.doQuery<FreeTextToPatientCaseQuery>(
      {
        query: Web.FreeTextToPatientCase,
        variables: { text },
      },
      true,
    );

    return result.freeTextToPatientCase;
  }
  async setVersionState(
    env: string,
    version: string,
    state: GVersionState,
  ): Promise<boolean> {
    const res = await this.doMutate<SetVersionStateMutation>({
      mutation: Web.SetVersionState,
      variables: { env, version, state },
    });
    return res?.setVersionState;
  }
  async setVersionRunningEnv(
    env: string,
    version: string,
    runningEnv: string[],
  ): Promise<boolean> {
    const res = await this.doMutate<SetVersionRunningEnvMutation>({
      mutation: Web.SetVersionRunningEnv,
      variables: { env, version, runningEnv },
    });
    return res?.setVersionRunningEnv;
  }
  async lambdaTests(
    devEnv: string,
    project: string,
    headline: string,
    cases: string,
    multiFilter: string,
    tagsFilter: string,
    taskVersion: string,
    modelVersion: string,
    filter: string,
    concurrency: number,
    panel: string,
    keepFunctions: number,
    disableLogs: number,
    loops: string,
    cached = false,
  ): Promise<string> {
    let result = await this.doMutate<LambdaTestsMutation>(
      {
        mutation: Web.LambdaTests,
        variables: {
          devEnv,
          project,
          headline,
          cases,
          multiFilter,
          tagsFilter,
          taskVersion,
          modelVersion,
          filter,
          panel,
          keepFunctions,
          disableLogs,
          concurrency,
          loops,
        },
      },
      cached,
    );
    return result.lambdaTests.success;
  }

  async getConversationExchange(
    patient: GroupedFeature[],
    patientVolunteered: number[],
    context: ConversationContext,
    missingInCase: MissingInCaseAction,
    stopQuestions: boolean,
    cached = false,
  ): Promise<ConversationExchangeResultFragment> {
    let variables: DoPatientExchangeQueryVariables = {
      context,
      patient,
      patientVolunteered,
      missingInCase,
      conversationOptions: {
        ...(await this.getConversationOptions()),
        shouldStop: stopQuestions,
      },
    };

    let results = await this.doQuery<DoPatientExchangeQuery>(
      {
        query: Web.Conversation.DoExchange,
        variables,
      },
      cached,
    );
    return results?.conversation?.state?.doExchange;
  }
  async getConversationResult(
    patient: GroupedFeature[],
    patientVolunteered: number[],
    context: ConversationContext,
    missingInCase: MissingInCaseAction,
    stopQuestions: boolean,
    cached = false,
  ): Promise<any> {
    let variables: DoPatientExchangeQueryVariables = {
      context,
      patient,
      patientVolunteered,
      missingInCase,
      conversationOptions: {
        ...(await this.getConversationOptions()),
        shouldStop: stopQuestions,
        forceReasoningComputation: true,
      },
    };

    let results = await this.doQuery<DoPatientExchangeQuery>(
      {
        query: Web.Conversation.DoExchangeResult,
        variables,
      },
      cached,
    );
    return results || null;
  }

  async saveConversationAsNew(
    context: ConversationContext,
    readOnly: boolean,
    cached = false,
  ): Promise<string> {
    let variables = {
      context,
      readOnly,
      conversationOptions: await this.getConversationOptions(),
    };

    let results = await this.doQuery<SaveAsPatientConversationQuery>(
      {
        query: Web.Conversation.SaveAs,
        variables,
      },
      cached,
    );
    return results?.conversation?.saveAsNewCase?.caseId;
  }

  async buildCaseFromConversation(
    context: ConversationContext,
    buildCaseOptions: BuildCaseOptions,
    caseId: string = null,
    cached = false,
  ) {
    let variables: BuildCaseFromConversationQueryVariables = {
      context,
      buildCaseOptions,
      conversationOptions: await this.getConversationOptions(),
      caseId,
    };

    let result = await this.doQuery<BuildCaseFromConversationQuery>(
      {
        query: Web.Conversation.BuildCase,
        variables,
      },
      cached,
    );
    return result.conversation.buildSavedCase;
  }

  async abandoned(context, saveToCase = true, debug = false) {
    let variables: AbandonedPatientConversationQueryVariables = {
      debug,
      saveToCase,
      context,
      conversationOptions: await this.getConversationOptions(),
      abandonedStatus: SubStatus.Skipped,
    };

    let results = await this.doQuery<AbandonedPatientConversationQuery>(
      {
        query: Web.Conversation.Abandoned,
        variables,
      },
      false,
    );
    return results?.conversation?.state?.abandoned;
  }

  async getNextResponse(
    context: ConversationContext,
    debug: boolean = false,
    saveToCase = false,
  ) {
    let variables: NextResponseQueryVariables = {
      context,
      debug,
      conversationOptions: await this.getConversationOptions(),
      saveToCase,
    };

    let results = await this.doQuery<NextResponseQuery>(
      {
        query: Web.Conversation.NextResponse,
        variables,
      },
      false,
    );
    this.updateModelRevisionInUse(results);
    return results?.conversation.state;
  }

  async addConversationFindings(
    {
      qfs,
      type,
      skipped = false,
      context,
      debug = false,
      saveToCase = false,
      source,
    }: {
      qfs: Partial<Record<CaseFindingPresentationType, QualifiedFeature[]>>;
      type: ConversationQuestionType;
      skipped: boolean;
      context: ConversationContext;
      debug: boolean;
      saveToCase: boolean;
      source: FindingSource;
    },
    cached = false,
  ) {
    let findings = this.asGFeatures(qfs, source);

    let variables: AddPatientAnswerConversationQueryVariables = {
      context,
      answer: {
        findings,
        skipped,
        questionType: type,
      },
      debug,
      conversationOptions: await this.getConversationOptions(),
      saveToCase,
    };

    let results = await this.doQuery<AddPatientAnswerConversationQuery>(
      {
        query: Web.Conversation.AddFindings,
        variables,
      },
      cached,
    );
    this.updateModelRevisionInUse(results);
    return results?.conversation?.state?.addAnswer;
  }

  async startConversation(
    caseId?: string,
    clinicId?: string,
    debug?: boolean,
    cached = false,
  ) {
    const variables: StartConversationQueryVariables = {
      patientCaseId: caseId,
      clinicId,
      debug,
      conversationOptions: {
        ...(await this.getConversationOptions()),
        forceReasoningComputation: debug,
      },
    };
    let results = await this.doQuery<StartConversationQuery>(
      {
        query: Web.Conversation.Start,
        variables,
      },
      cached,
    );
    this.updateModelRevisionInUse(results);
    return results?.conversation?.start;
  }

  async runDDForConversation(context: ConversationContext, cached = false) {
    let variables: DdFromConversationQueryVariables = {
      context,
      conversationOptions: await this.getConversationOptions(),
    };

    let results = await this.doQuery<DdFromConversationQuery>(
      {
        query: Web.Conversation.DD,
        variables,
      },
      cached,
    );

    let dd = results?.conversation?.state?.ddClusters;
    let primaryDDClusters = results?.conversation?.state?.primaryDDClusters;
    const urgent = results.conversation.state.urgent;
    const navigationRecommendation =
      results.conversation.state.navigationRecommendation;

    const updatedDD = this.getDDFindings(dd);

    return {
      ddClusters: updatedDD,
      primaryDDClusters,
      urgent,
      navigationRecommendation,
    };
  }

  async restoreOpaqueData(id: string, type: string, cached: boolean = false) {
    const variables: RestoreOpaqueDataQueryVariables = {
      id,
      type,
    };

    return (
      await this.doQuery<RestoreOpaqueDataQuery>(
        {
          query: Web.RestoreOpaqueData,
          variables,
        },
        cached,
      )
    )?.restoreOpaqueData;
  }

  async getPatientFirstSummary(
    id: string,
    clinicId: string,
    options: SummaryOptions = null, // new
    cached: boolean = false,
    lang?: string,
  ) {
    const variables: PatientSummaryQueryVariables = {
      id,
      clinicId,
      summaryOptions: options,
      conversationOptionsInput: {
        lang, //Thats just a WA to cause a different request per language and to break the appolo client in-memory cache. It is easy to do that since it is a scalar
        ...(await this.getConversationOptions()),
      },
    };

    return (
      await this.doQuery<PatientSummaryQuery>(
        {
          query: Web.Conversation.PatientFirstSummaryById,
          variables,
        },
        cached,
        lang && { "kahun-langcode": lang },
      )
    ).patientSummary;
  }

  async updatePatientSummary(
    caseId: string,
    clinicId: string,
    summaryInput: SummaryInput,
  ) {
    const variables: UpdatePatientSummaryMutationVariables = {
      caseId,
      clinicId,
      summaryInput,
    };
    return (
      await this.doMutate<UpdatePatientSummaryMutation>({
        mutation: Web.UpdatePatientSummary,
        variables,
      })
    ).updateSummary;
  }

  async checkForPII(input: string) {
    return (
      await this.doQuery<CheckForPiiQuery>(
        {
          query: Web.CheckForPII,
          variables: {
            input,
          },
        },
        false,
      )
    )?.checkForPII;
  }

  async getPatientSummaryByCase(
    qfs: Partial<Record<CaseFindingPresentationType, QualifiedFeature[]>>,
    diseases: QualifiedFeature[],
    suggestions: QualifiedFeature[],
    options: SummaryOptions,
    cached: boolean = false,
  ) {
    const gfeatures = this.asGFeatures(qfs);
    const diseasesInput = diseases.map(asQualifiedFeatureInput);
    const suggestionsInput = suggestions.map(asQualifiedFeatureInput);

    const variables: PatientSummaryByCaseQueryVariables = {
      patientCase: { findings: gfeatures },
      diseases: diseasesInput,
      suggestions: suggestionsInput,
      summaryOptions: options,
    };

    return (
      await this.doQuery<PatientSummaryByCaseQuery>(
        {
          query: Web.PatientSummaryByCase,
          variables,
        },
        cached,
      )
    ).patientSummaryByCase;
  }

  async getPatientFirstSummaryByContext(
    context: ConversationContext,
    options: SummaryOptions,
    cached: boolean = false,
  ) {
    // Merge conversation options with the options the client sends
    const _conversationOptions = await this.getConversationOptions();
    const conversationOptions = {
      ..._conversationOptions,
      ...prefixConfigPath(["summaryOptions"], options),
    };
    const variables: PatientSummaryByContextQueryVariables = {
      context,
      conversationOptions,
    };

    return (
      await this.doQuery<PatientSummaryByContextQuery>(
        {
          query: Web.Conversation.PatientFirstSummaryByContext,
          variables,
        },
        cached,
      )
    ).conversation.state;
  }

  async getMetrics(qfs: WQualifiedFeature[]) {
    const input = qfs.map(asQualifiedFeatureInputFromW);
    const variables: MetricsQfQueryVariables = {
      qfs: input,
    };

    return (
      await this.doQuery<MetricsQfQuery>({
        query: Web.QFMetrics,
        variables,
      })
    ).metricsQF;
  }

  async getQFSCorrlate(qfs1: WQualifiedFeature[], qfs2: WQualifiedFeature[]) {
    const input1 = qfs1.map(asQualifiedFeatureInputFromW);
    const input2 = qfs2.map(asQualifiedFeatureInputFromW);
    const variables: QfsCorrelateQueryVariables = {
      qfs1: input1,
      qfs2: input2,
    };

    return (
      await this.doQuery<QfsCorrelateQuery>({
        query: Web.QFSCorrlate,
        variables,
      })
    ).qfsCorrelate;
  }

  async getQFSCorrlateLists(
    qfsList1: QualifiedFeatureInput[][],
    qfsList2: QualifiedFeatureInput[][],
  ) {
    const variables: QfsCorrelateListsQueryVariables = {
      qfsList1: qfsList1,
      qfsList2: qfsList2,
    };

    return (
      await this.doQuery<QfsCorrelateListsQuery>({
        query: Web.QFSCorrlateLists,
        variables,
      })
    ).qfsCorrelateLists;
  }

  async restoreConversation(
    context: ConversationContext,
    debug: boolean,
    privateMode: boolean = false,
  ) {
    const variables: RestoreConversationQueryVariables = {
      context,
      debug,
      privateMode,
      conversationOptions: {
        ...(await this.getConversationOptions()),
        // Make sure we always get reasoning, regardless of solver optimisation
        forceReasoningComputation: debug,
      },
    };

    const results = await this.doQuery<RestoreConversationQuery>({
      query: Web.Conversation.RestoreConversation,
      variables,
    });

    this.updateModelRevisionInUse(results);

    return results.conversation.state;
  }

  async getConversationRecomandations(patientCaseId: string, clinicId: string) {
    const variables: GetRecommendationsQueryVariables = {
      patientCaseId,
      saveToCase: false,
      clinicId,
      conversationOptions: {
        ...(await this.getConversationOptions()),
      },
    };

    const results = await this.doQuery<GetRecommendationsQuery>({
      query: Web.Conversation.GetRecommendations,
      variables,
    });

    return results.conversation.start;
  }

  async loadDebugForLastQuestion(
    context: ConversationContext,
    privateMode: boolean = false,
    lastQuestionIndex = -1,
  ) {
    const endExchangeIndex = !context?.exchanges?.length
      ? -1
      : lastQuestionIndex > -1
      ? lastQuestionIndex
      : context.exchanges.length -
        (context.exchanges[context.exchanges.length - 1]?.wasAnswered ? 0 : 1);
    const variables: DebugForLastQuestionQueryVariables = {
      context,
      debug: true,
      privateMode,
      conversationOptions: {
        ...(await this.getConversationOptions()),
        // Make sure we always get reasoning, regardless of solver optimisation
        forceReasoningComputation: true,
        "resultsDD.forceRecompute": true,
        "resultsDD.outputUsedPaths": true,
        "nextStepDD.forceRecompute": true,
        "nextStepDD.outputUsedPaths": true,
        nextStepCategories: [
          "OUTCOME_SIGNS",
          "PATIENT_FINDINGS_DECENDANTS",
          "BACKGROUND",
          "OUTCOME_VITALSIGN",
          "OUTCOME_TEST",
          "IMAGING",
        ],
      },
      endExchangeIndex,
    };

    const results = await this.doQuery<DebugForLastQuestionQuery>({
      query: Web.Conversation.DebugForLastQuestion,
      variables,
    });

    this.updateModelRevisionInUse(results);

    return results.conversation.state;
  }

  async getReasoning(context: ConversationContext, endExchangeIndex?: number) {
    const convOptions = await this.getConversationOptions();
    const variables: ConversationNextQuestionQueryVariables = {
      context,
      conversationOptions: {
        ...convOptions,
        // Make sure to bring citaitons for cr
        includeDiseaseCitations: true,
        // Make sure we always get reasoning, regardless of solver optimisation
        forceReasoningComputation: true,
        "resultsDD.forceRecompute": true,
        "resultsDD.outputUsedPaths": true,
        "nextStepDD.forceRecompute": true,
        "nextStepDD.outputUsedPaths": true,
      },
      endExchangeIndex,
      debug: true,
    };

    return (
      await this.doQuery<ConversationNextQuestionQuery>({
        query: Web.Conversation.ConversationNextQuestion,
        variables,
      })
    ).conversation.state;
  }

  async persistConversation(context: ConversationContext) {
    const variables: PersistConversationQueryVariables = {
      context,
      conversationOptions: await this.getConversationOptions(),
    };

    return (
      await this.doQuery<PersistConversationQuery>({
        query: Web.Conversation.Persist,
        variables,
      })
    ).conversation.state.context;
  }

  async persistConversationById(id: string) {
    const variables: PersistConversationByIdQueryVariables = {
      existingCaseId: id,
      conversationOptions: await this.getConversationOptions(),
    };

    return (
      await this.doQuery<PersistConversationByIdQuery>({
        query: Web.Conversation.PersistById,
        variables,
      })
    ).conversation.start.persist;
  }

  async undoConversation(context: ConversationContext, debug: boolean) {
    const variables: UndoConversationQueryVariables = {
      context,
      debug,
      conversationOptions: await this.getConversationOptions(),
    };

    return (
      await this.doQuery<UndoConversationQuery>({
        query: Web.Conversation.Undo,
        variables,
      })
    ).conversation.state.undo;
  }

  async getOptions(name: string): Promise<any> {
    return (
      await this.doQuery({
        query: TypeIntrospectionQuery,
        variables: { name },
      })
    ).__type.inputFields;
  }

  async getPathsBetweenFeatures(
    qFeatureFrom: QualifiedFeature,
    qFeatureTo: QualifiedFeature,
    toIsDisease: boolean,
    patientInput?: GroupedFeatureResponseFragment[],
  ): Promise<MetricsPathsQuery> {
    const patient = {
      findings:
        patientInput?.map((gf) => asGroupedFeature(gf.group)(gf.feature)) || [],
    };
    const variables: MetricsPathsQueryVariables = {
      causeqfs: [qFeatureFrom].map(asQualifiedFeatureInput),
      effectqfs: [qFeatureTo].map(asQualifiedFeatureInput),
      causeids: [],
      effectids: [],
      effectIsDisease: toIsDisease,
      patient,
    };

    return await this.doQuery<MetricsPathsQuery>({
      query: Web.metricsPaths,
      variables,
    });
  }

  async getUserRoles(): Promise<string[]> {
    return (
      await this.doQuery<GetUserRolesQuery>({
        query: Web.UserRoles,
      })
    ).getUserRoles;
  }
}

function prefixConfigPath(path: string[], obj: Object) {
  const prefix = path?.map((p) => `${p}.`).join("") || "";
  const entries = Object.entries(obj || {}).map(([k, v]) => [prefix + k, v]);
  return Object.fromEntries(entries);
}
